import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import GoodsRegardingsDetailSkeleton from "./GoodsRegardingsDetailSkeleton";
import { GoodsRegardingsDto } from "../../../../../dtos/documents/GoodsRegardings/GoodsRegardingsDto";
import { GoodsREgardingsModel } from "../../../../../models/Documents/GoodsRegardings/GoodsRegardingsModel";
import { NewDocumentModalViewContext } from "../../../../Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../../Shared/NewForms/NFTabs";
import { NFSecondTab } from "../../../../Shared/NewForms/NFSecondTab";
import { DocumentModalViewHeader } from "../../../../Shared/DocumentModalViewHeader";
import { NFTabContainer } from "../../../../Shared/NewForms/NFTabContainer";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFLookupUnit } from "../../../../Shared/NewForms/NFLookupUnit";
import { NFLookupAccount } from "../../../../Shared/NewForms/NFLookupAccount";
import { NFLookupVendor } from "../../../../Shared/NewForms/NFLookupVendor";
import { NFTextAreaInput } from "../../../../Shared/NewForms/NFTextAreaInput";
import { GoodsRegardingsDetailFooter } from "./GoodsRegardingsDetailFooter";
import { AppEntities } from "../../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../../helpers/SaveObjectToExcel";
import DocumentDetailViewToolbar from "../../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: GoodsRegardingsDto | null;
  modelUpdatedEvent: (newModel: GoodsRegardingsDto) => void;
}

export const GoodsRegardingsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<GoodsREgardingsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("goodsRegradingGoodUnpostings");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Goods Regradings");

  useEffect(() => {
    console.log(model);
    register("goodsRegradingGoodPostings");
    register("goodsRegradingGoodUnpostings");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("companyId", model.companyId);
      setValue("createdDate", model.createdDate);
      setValue("warehouseId", model.warehouseId);
      setValue("divisionId", model.divisionId);
      setValue("comment", model.comment);
      setValue("divisionId", model.divisionId);
      setValue("goodsRegradingGoodPostings", model.goodsRegradingGoodPostings);
      setValue("goodsRegradingGoodUnpostings", model.goodsRegradingGoodUnpostings);
    }
  }, [model]);

  useEffect(() => {
    // console.log(watchProducts);
  }, [watchProducts]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: GoodsREgardingsModel
  // ) => {
  //   if (action === "save") {
  //     const newModel: GoodsRegardingsDto = { ...model, ...data };
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: GoodsREgardingsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <GoodsRegardingsDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.GoodsRegardings.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`goodsRegradingGoodPostings.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`goodsRegradingGoodPostings.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Good postings"} />
        <NFSecondTab title={"Good unpostings"} />
        <NFSecondTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision companyId={watch("companyId")} fieldName={"divisionId"} title={"Division"} required />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupWarehouse fieldName={"warehouseId"} title={"Warehouse"} required companyId={watch("companyId")} />
            </Col>
            <Col sm={6}></Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"goodsRegradingGoodPostings"}>
            <NFLookupProduct fieldName={"productId"} title={"Product"} width={200} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} onValueChanged={handleQuantityChanged} />
            <NFLookupUnit fieldName={"unitId"} title={"Unit"} width={200} />
            <NFLookupUnit fieldName="unitGoodsPostingId" title="Unit goods posting" />
            <NFLookupProduct fieldName="productGoodsPostingId" title="Product goods posting" />
            <NFLookupAccount fieldName="recipientAccountId" title="Recipient account" width={200} />
            <NFLookupAccount fieldName="accountingAccountId" title="Accounting account" />
            <NFIntInput fieldName={"price"} title={"Price"} onValueChanged={handlePriceChanged} width={100} />
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <NFormTable fieldArray={"goodsRegradingGoodUnpostings"}>
            <NFLookupProduct fieldName={"productId"} title={"Product"} width={200} />
            <NFLookupVendor fieldName={"vendorCode"} title={"Vendor"} width={200} />
            <NFTextInput fieldName={"productCode"} title={"Product code"} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} />
            <NFLookupUnit fieldName={"unitId"} title={"Unit"} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <GoodsRegardingsDetailFooter />
    </FormProvider>
  );
};
